import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  getApiClient,
  makeStandardApiErrorHandler,
} from "../../../server/get_api_client";
import SideMenu from "../SideMenu";
import RequireLogin from "../../../permissions.js/RequireLogin";
import Card from "./Card";
import LI from "../../../SVGs/LI.svg";
import DI from "../../../SVGs/DI.svg";
import AI from "../../../SVGs/AI.svg";
import UI from "../../../SVGs/UI.svg";
import HO from "../../../SVGs/HO.svg";
import RI from "../../../SVGs/RI.svg";
import Nav from "../../Common/Nav";
import Footer from "../../Common/Footer";
import NothingToShow from "../../Common/NothingToShow";
import Cookies from "js-cookie";
import PageLoader from "../../Common/PageLoader";

function SpousePolicies() {
  const [allPolicies, setAllPolicies] = useState();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const userid = Cookies.get("hippocratic_portal_contactid");
    setIsLoading(true);
    getApiClient()
      .getMembers(userid)
      .then((res) => {
        if (res.data) {
          const spouseMembers = res.data.members.filter(
            (member) => member.contactid !== userid && member.Type == 0
          );
          if (spouseMembers.length > 0) {
            const spouseId = spouseMembers[0].contactid;
            return getApiClient().getAllInforcePolicies(spouseId);
          }
        }
        return null;
      })
      .then((policiesRes) => {
        if (policiesRes) {
          setAllPolicies(policiesRes.data);
        }
      })
      .catch(makeStandardApiErrorHandler((error) => console.log(error)))
      .finally(() => setIsLoading(false));
  }, []);

  const hasPolicies = allPolicies
    ? Object.values(allPolicies).some((policies) => policies.length > 0)
    : false;

  return (
    <>
      <PageLoader isLoading={isLoading} />
      <Nav />
      <Container>
        <TopSection>
          <NavigationInformation>
            Home &gt; My Profile &gt; Spouse &gt; Spouse Policies
          </NavigationInformation>
          <Title>Spouse Policies</Title>
        </TopSection>
        <BottomSection>
          <SideMenu />
          {hasPolicies ? (
            <RightContainer>
              {allPolicies?.LI?.length > 0 && (
                <Card
                  Title="Life Insurance"
                  policies={allPolicies.LI}
                  Icon={LI}
                />
              )}
              {allPolicies?.DI?.length > 0 && (
                <Card
                  Title="Disability Insurance"
                  policies={allPolicies.DI}
                  Icon={DI}
                />
              )}
              {allPolicies?.Auto?.length > 0 && (
                <Card
                  Title="Auto Insurance Policies"
                  policies={allPolicies.Auto}
                  Icon={AI}
                  hideBenifets={true}
                />
              )}
              {allPolicies?.Umbrella?.length > 0 && (
                <Card
                  Title="Umbrella Insurance Policies"
                  policies={allPolicies.Umbrella}
                  Icon={UI}
                  hideBenifets={true}
                />
              )}
              {allPolicies?.HomeOwners?.length > 0 && (
                <Card
                  Title="Home Owners Insurance Policies"
                  policies={allPolicies.HomeOwners}
                  Icon={HO}
                  hideBenifets={true}
                />
              )}
              {allPolicies?.Renters?.length > 0 && (
                <Card
                  Title="Renters Insurance Policies"
                  policies={allPolicies.Renters}
                  Icon={RI}
                  hideBenifets={true}
                />
              )}
            </RightContainer>
          ) : (
            <NothingToShow
              background={"#FFF7EC"}
              text="No active policies found for your spouse."
            />
          )}
        </BottomSection>
      </Container>
      <Footer />
    </>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 85vh;
  gap: 50px;
  padding: 0px 5vw;
`;

const TopSection = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  gap: 30px;
`;

const NavigationInformation = styled.div`
  color: var(--darkBlue);
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;

const Title = styled.div`
  color: var(--darkBlue);
  font-family: Georgia;
  font-size: 55px;
  font-style: normal;
  font-weight: 400;
  line-height: 90%;
  letter-spacing: -1.1px;

  @media screen and (max-width: 719px) {
    font-size: 40px;
  }
`;

const BottomSection = styled.div`
  display: flex;
  gap: 30px;
`;

const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
`;

export default RequireLogin(SpousePolicies);
